import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminTableToolbarComponent } from '../admin-table-toolbar/admin-table-toolbar.component';

@Component({
  selector: 'app-admin-list-toolbar',
  standalone: true,
  imports: [CommonModule, AdminTableToolbarComponent],
  templateUrl: './admin-list-toolbar.component.html',
})
export class AdminListToolbarComponent {
  @Input() titleKey = '';
  @Input() descriptionKey = '';
  @Input() showSearch = false;
  @Input() searchPlaceholderKey = 'COMMON.SEARCH';
  @Input() searchValue = '';

  @Output() searchValueChange = new EventEmitter<string>();

  onSearchChange(value: string): void {
    this.searchValueChange.emit(value);
  }
}
